import { gqlClient } from '@/api/graphql-client';
import { ASSIGN_INBOUND_EMAIL_TO_PROJECT_MUTATION } from '@/api/mutations/inbound-emails/useAssignInboundEmailToProject';
import {
  AssignInboundEmailToProjectMutation,
  AssignInboundEmailToProjectMutationVariables,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { createOptimisticMutationOptions } from './createOptimisticMutation';
import {
  applyDetailOptimisticAssignToProject,
  applyOptimisticAssignToProject,
} from './optimisticUpdates';

type AssignInboundEmailToProjectVariables =
  AssignInboundEmailToProjectMutationVariables & {
    projectReference: string;
  };

const useOptimisticAssignInboundEmailToProject = (
  options?: UseMutationOptions<
    AssignInboundEmailToProjectMutation,
    unknown,
    AssignInboundEmailToProjectVariables
  >
) => {
  const queryClient = useQueryClient();

  const optimistic = createOptimisticMutationOptions(
    queryClient,
    {
      applyToInbox: applyOptimisticAssignToProject,
      applyToDetail: applyDetailOptimisticAssignToProject,
      tracksUnreadCount: false,
    },
    options
  );

  return useMutation({
    mutationFn: ({
      inboundEmailId,
      projectId,
    }: AssignInboundEmailToProjectVariables) =>
      gqlClient.request(ASSIGN_INBOUND_EMAIL_TO_PROJECT_MUTATION, {
        inboundEmailId,
        projectId,
      }),
    ...options,
    ...optimistic,
  });
};

export default useOptimisticAssignInboundEmailToProject;
